import { ReactElement, useMemo } from 'react';

import { useSubscription } from '~hooks/useSubscription';
import { useSubscriptionFeatures } from '~hooks/useSubscriptionFeatures';
import { isCorporate, isPlanCorporate } from '~utils/plans';

import AccessFeatureUpgradePlanButtonContactSales from '../ContactSales';
import AccessFeatureUpgradePlanButtonShowPlan from '../ShowPlan';

import { AccessFeatureUpgradePlanButtonProps } from '../types';

const AccessFeatureUpgradePlanButtonBase = ({
  validFeature,
  ...restProps
}: AccessFeatureUpgradePlanButtonProps): ReactElement => {
  const subscription = useSubscription();
  const { getNextPlanFeature } = useSubscriptionFeatures();

  const isLastPlan = useMemo(() => {
    if (!validFeature) {
      const isCurrentPlanCorporate = isPlanCorporate(subscription);

      return isCurrentPlanCorporate;
    }

    const nextPlanName = getNextPlanFeature(validFeature);

    return isCorporate(nextPlanName);
  }, [getNextPlanFeature, subscription, validFeature]);

  const ButtonComponent = useMemo(
    () =>
      isLastPlan
        ? AccessFeatureUpgradePlanButtonContactSales
        : AccessFeatureUpgradePlanButtonShowPlan,
    [isLastPlan],
  );

  return <ButtonComponent {...restProps} />;
};

export default AccessFeatureUpgradePlanButtonBase;
